import SecurityIcon from "./security-icon";
export default SecurityIcon;